import React from 'react';
import MainMenu from './MainMenu';
import Button from './Button';
import '../styles/ProjectTemplate.css';

function ProjectTemplate({ title, sections, year }) {
  return (
    <div className="project-page">
      {/* Main Menu */}
      <MainMenu />
      
      <div className="project-header-row">
        {/* Left Arrow: Back to Projects */}
        <div className="nav-arrow left">
          <Button
            title="<"
            link="/projects"
            styleType="outline-custom"
            size="back"
          />
        </div>
        
        <div className="project-title-year">
          <h1 className="project-title">{title}</h1>
          <h1 className="project-year">{year}</h1>
        </div>
        
        {/* Right Arrow Removed */}
        <div className="nav-arrow right"></div>
      </div>
      
      {/* Dynamic Sections */}
      <div className="project-sections">
        {sections.map((section, index) => {
          if (section.type === 'video') {
            return (
              <div key={index} className="project-media">
                {section.links.map((link, linkIndex) => (
                  <div key={linkIndex}>
                    <iframe
                      src={link}
                      allowFullScreen
                      frameBorder="0"
                      className="video-iframe"
                    />
                  </div>
                ))}
              </div>
            );
          } else if (section.type === 'image') {
            // Determine if this is a grid layout (multiple images) or single image
            const isGridLayout = section.links.length > 1;
            
            return (
              <div key={index} className={`project-media ${isGridLayout ? 'grid-layout' : ''}`}>
                {section.links.map((link, linkIndex) => (
                  <div key={linkIndex} className="image-container">
                    {section.isLink ? (
                      <a href={link.href} target="_blank" rel="noopener noreferrer">
                        {link.text && (<div className="image-label">{link.text}</div>)}
                        <img
                          src={link.src}
                          alt={`media-${linkIndex}`}
                          className="project-image"
                        />
                        {link.year && (<div className="image-label">{link.year}</div>)}
                      </a>
                    ) : (
                      <>
                        {link.text && (<div className="image-label">{link.text}</div>)}
                        <img
                          src={link.src}
                          alt={`media-${linkIndex}`}
                          className="project-image"
                        />
                      </>
                    )}
                  </div>
                ))}
              </div>
            );
          } else if (section.type === 'description') {
            return (
              <section key={index} className="project-description">
                {section.content || <p>{section.text}</p>}
              </section>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
}

export default ProjectTemplate;